import css from 'styled-jsx/css'

export const FormCellStyles = css`
  div :global(.cell-width-1 > .field-container > div > .field-label),
  div :global(.cell-width-1 > .field-container > div > span),
  div :global(.cell-width-1 > .field-container > .datePickerComponent > div .field-label),
  div :global(.cell-width-1 > .field-container > div.input-checkbox .field-label),
  div :global(.cell-width-1 > .field-container > div.output > .output-wrapper > .field-label),
  div :global(.cell-width-1 > .field-container > div.output > .output-wrapper > span) {
    flex: 0 0 25%;
  }

  div :global(.cell-width-2 > .field-container > div > .field-label),
  div :global(.cell-width-2 > .field-container > div > span),
  div :global(.cell-width-2 > .field-container > .datePickerComponent > div .field-label),
  div :global(.cell-width-2 > .field-container > div.input-checkbox .field-label),
  div :global(.cell-width-2 > .field-container > div.output > .output-wrapper > .field-label),
  div :global(.cell-width-2 > .field-container > div.output > .output-wrapper > span) {
    flex: 0 0 12.5%;
  }
  div :global(.cell-width-3 > .field-container > div > .field-label),
  div :global(.cell-width-3 > .field-container > div > span),
  div :global(.cell-width-3 > .field-container > .datePickerComponent > div .field-label),
  div :global(.cell-width-3 > .field-container > div.input-checkbox .field-label),
  div :global(.cell-width-3 > .field-container > div.output > .output-wrapper > .field-label),
  div :global(.cell-width-3 > .field-container > div.output > .output-wrapper > span) {
    flex: 0 0 7.8%;
  }
`

export const noCellStyles = css`.noCellStyles {}`
